import { request } from '@/shared/api/http-client'
import { emptyEnvelopeSchema } from '@/shared/api/api-contract'
import type { TaskCapability, TaskStatus } from '../model/generation-task'
import { quoteEnvelopeSchema, taskEnvelopeSchema, taskListEnvelopeSchema, type TaskInput } from './task-contract'

export interface ListTasksParams {
  page?: number
  pageSize?: number
  modelId?: number
  capability?: TaskCapability
  status?: TaskStatus
}

export interface TaskDraft {
  modelId: number
  capability: TaskCapability
  input: TaskInput
}

export function quoteTask(draft: TaskDraft, signal?: AbortSignal) {
  return request('/member/ai/tasks/quote', {
    method: 'POST',
    body: draft,
    schema: quoteEnvelopeSchema,
    ...(signal ? { signal } : {}),
  })
}

export function createTask(draft: TaskDraft, expectedPoints: number) {
  return request('/member/ai/tasks', { method: 'POST', body: { ...draft, expectedPoints }, schema: taskEnvelopeSchema })
}

export function listTasks(params: ListTasksParams = {}) {
  const query = new URLSearchParams({
    page: String(params.page ?? 1),
    size: String(params.pageSize ?? 20),
  })
  if (params.modelId !== undefined) query.set('modelId', String(params.modelId))
  if (params.capability) query.set('capability', params.capability)
  if (params.status) query.set('status', params.status)
  return request(`/member/ai/tasks?${query.toString()}`, { method: 'GET', schema: taskListEnvelopeSchema })
}

export function getTask(taskNo: string) {
  return request(`/member/ai/tasks/${encodeURIComponent(taskNo)}`, { method: 'GET', schema: taskEnvelopeSchema })
}

export function cancelTask(taskNo: string) {
  return request(`/member/ai/tasks/${encodeURIComponent(taskNo)}/cancel`, { method: 'POST', schema: emptyEnvelopeSchema })
}
